var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChemistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chemistry",
    transform: "translate(21301 -1955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4660",
    "data-name": "Rectangle 4660",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21301 1955)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_27",
    "data-name": "Union 27",
    d: "M-8036.967-6884.237a1.78,1.78,0,0,1-1.618-.82,3.02,3.02,0,0,1,0-2.545,9.03,9.03,0,0,1,.545-1.292l9.944-19.03.009-.019a15.033,15.033,0,0,0,1.166-5.256v-16.181a2.487,2.487,0,0,1-1.28-2.277v-.054a2.277,2.277,0,0,1,1.314-1.986,3.277,3.277,0,0,1,1.382-.3h10.487a3.288,3.288,0,0,1,1.384.3,2.286,2.286,0,0,1,1.314,1.986v.054a2.489,2.489,0,0,1-1.282,2.277v16.183a15.224,15.224,0,0,0,1.166,5.256l.02.038,9.935,19.01a9.659,9.659,0,0,1,.542,1.292,3.031,3.031,0,0,1,0,2.544,1.767,1.767,0,0,1-1.618.82Zm25.857-17.506-2.8-5.36c-1.152-1.978-1.378-5.859-1.391-6.024V-6930.9h.849c.131,0,.228-.017.326-.243a1.55,1.55,0,0,0,.108-.492.584.584,0,0,0-.355-.538,1.58,1.58,0,0,0-.649-.135H-8025.5a1.578,1.578,0,0,0-.647.135.58.58,0,0,0-.355.538,1.55,1.55,0,0,0,.108.492c.1.226.192.243.323.243h.847v17.771c-.012.166-.24,4.052-1.387,6.025l-2.8,5.361h11.122v-.436h-2.474v-.649h2.474v-1.979h-2.458v-.639h2.458v-2.265h-2.458v-.638h2.458v-2.021h-2.458v-.639h2.458v-2.263h-2.458v-.641h2.458v-1.922h-2.458v-.64h2.458v-2.262h-2.458v-.64h2.458v-2.117h-2.458v-.641h2.458v-2.259h-2.458v-.641h2.458v-2.459h1.07v25.749Z",
    transform: "translate(-13236.14 8909)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistry);
export default __webpack_public_path__ + "static/media/Chemistry.ed7a7a90.svg";
export { ForwardRef as ReactComponent };